import IEmptyProps from "EmptyProps";
import IEmptyState from "EmptyState";
import React from 'react';
import BeerItem from "Pages/Alcohol/BeerItem";
import PageNavigationController from "PageNavigation/PageNavigationController";
import { dicontainer } from "DIContainer";
import Alert, { AlertType } from "CommonControls/Alert";

export default class Alcohol extends React.Component<IEmptyProps, IEmptyState> {
    private _pageNavigationController: PageNavigationController = dicontainer.get(PageNavigationController);
    
    public constructor(props: IEmptyProps) {
        super(props);
        this.state = {}
        this.handleContactClick = this.handleContactClick.bind(this);
    }

    private handleContactClick() {
        this._pageNavigationController.switch("accueil", "nous-joindre");
    }

    public render() {
        return ([
            <div key="spacer" className="spacer"></div>,
            <div key="alerts" className="alerts">
                <Alert type={AlertType.Info}>
                    Taxes et consignes incluses. Prévoir 2 semaines pour la livraison. Commande minimale de 5 caisses de 12 par produit et 20 caisses de 12 au total. Ces produits peuvent être commandés par les associations étudiantes membres de l'AGÉTAAC (FSAA) uniquement. Contactez l'<a href="https://agetaac.asso.ulaval.ca/" target="_blank" className="color-inherit">AGÉTAAC</a> pour placer une commande.
                </Alert>
            </div>,
            <div key="ready-to-drink" className="section">
                <div className="header">
                    <div className="title-container">
                        <h2 className="title">
                            Prêt-à-boire
                        </h2>
                    </div>
                </div>
                <div className="content">
                    <div className="price-grid">
                        <BeerItem name={"Beach Day Every Day Saveurs variées"} numberOfUnits={12} volumeMl={355} bottling="cans" type="Boisson de malt" abv={5.4} country="Canada" price={14.41} thumbnailUrl="img/beers/beach-day-every-day-saveurs-variees.jpg" />
                        <BeerItem name={"Beach Day Every Orange"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Boisson de malt" abv={7} country="Canada" price={34.9} thumbnailUrl="img/beers/beach-day-every-day-orange.jpg" />
                        <BeerItem name={"Beach Day Every Smash"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Boisson de malt" abv={7} country="Canada" price={38.58} thumbnailUrl="img/beers/beach-day-every-day-smash.jpg" />
                        <BeerItem name={"NÜTRL Hard Seltzer"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Boisson de malt" abv={4} country="Canada" price={34.9} thumbnailUrl="img/beers/nutrl-hard-seltzer-saveurs-variees.jpg" />
                        <BeerItem name={"Palm Bay Mangue et goyave"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Boisson de malt" abv={7} country="Canada" price={34.9} thumbnailUrl="img/beers/palm-bay-mangue-goyave.jpg" />
                        <BeerItem name={"Palm Bay Saveurs variées"} numberOfUnits={15} volumeMl={355} bottling="cans" type="Boisson de malt" abv={5} country="Canada" price={14.71} thumbnailUrl="img/beers/palm-bay-saveurs-variees.jpg" />
                        <BeerItem name={"SVNS Hard 7up"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Boisson de malt" abv={7} country="Canada" price={38.58} thumbnailUrl="img/beers/svns-hard.jpg" />
                        <BeerItem name={"SVNS Hard 7up Limonade"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Boisson de malt" abv={7} country="Canada" price={38.58} thumbnailUrl="img/beers/svns-hard-limonade.jpg" />
                    </div>
                </div>
            </div>,
            <div key="premium" className="section">
                <div className="header">
                    <div className="title-container">
                        <h2 className="title">
                            Premium
                        </h2>
                    </div>
                </div>
                <div className="content">
                    <div className="price-grid">
                        <BeerItem name={"Bud Light"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Lager" abv={4} country="Canada" price={30.73} thumbnailUrl="img/beers/bud-light.jpg" />
                        <BeerItem name={"Budweiser"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Lager" abv={5} country="Canada" price={30.73} thumbnailUrl="img/beers/budweiser.jpg" />
                        <BeerItem name={"Labatt 50"} numberOfUnits={12} volumeMl={355} bottling="cans" type="Lager" abv={5} country="Canada" price={17.08} thumbnailUrl="img/beers/labatt-50.jpg" />
                        <BeerItem name={"Michelob ULTRA"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Lager" abv={4} country="Canada" price={32.91} thumbnailUrl="img/beers/michelob-ultra.jpg" />
                    </div>
                </div>
            </div>,
            <div key="premium" className="section">
                <div className="header">
                    <div className="title-container">
                        <h2 className="title">
                            Sans alcool
                        </h2>
                    </div>
                </div>
                <div className="content">
                    <div className="price-grid">
                        <BeerItem name={"Budweiser Zero"} numberOfUnits={12} volumeMl={355} bottling="cans" type="Lager" abv={5} country="Canada" price={17.08} thumbnailUrl="img/beers/budweiser-zero.jpg" />
                        <BeerItem name={"Corona Sunbrew"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Lager" abv={5} country="Canada" price={41.99} thumbnailUrl="img/beers/corona-sunbrew.jpg" />
                    </div>
                </div>
            </div>,
            <div key="imports" className="section">
                <div className="header">
                    <div className="title-container">
                        <h2 className="title">
                            Importées
                        </h2>
                    </div>
                </div>
                <div className="content">
                    <div className="price-grid">
                        <BeerItem name={"Corona Extra"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Lager" abv={4.6} country="Mexique" price={34.01} thumbnailUrl="img/beers/corona-extra.jpg" />
                        <BeerItem name={"Stella Artois"} numberOfUnits={24} volumeMl={355} bottling="cans" type="Lager" abv={5} country="Belgique" price={34.01} thumbnailUrl="img/beers/stella-artois.jpg" />
                    </div>
                </div>
            </div>,
        ]);
    }
}